import { defineStore } from "pinia";
import { ref } from "vue";
import appApi from "@/services/api";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";

const usePublicStore = defineStore("public", () => {
  const cardContainerClassDimensions = ref("col-md-9 col-lg-7 col-xl-7");
  //const cardContainerClassDimensions = ref("col-md-12 col-lg-11 col-xl-8");
  const showPhoneSection = ref(true);
  const showCodeSection = ref(false);
  const showGeneralesSection = ref(false);
  const showCotizacionSection = ref(false);
  const showCotizacionFinalizadaSection = ref(false);
  const globalPhone = ref("");
  const listEnganches = ref([]);
  const listResiduales = ref([]);
  const listEstados = ref([]);
  const listMunicipios = ref([]);
  const listArrendamientos = ref([]);
  const loadingInitialData = ref(true);
  const loadingMunicipios = ref(false);
  const formGenerales = ref("");
  const cotizacionFinal = ref([]);
  const modalAcciones = ref("");
  const formAprobar = ref(false);
  const formRechazar = ref(false);
  const Close = ref("");

  const mostrarPasoDatos = ref(true);
  const mostrarPasoDatosEmpresa = ref(false);
  const mostrarPasoDatosActivo = ref(false);
  const mostrarPasoCotFinalizada = ref(false);
  const leyendaPaso = ref("Paso 1: Vericación de datos");

  const state = ref({
    celular: "",
    correo: "",
  });

  const fetchInitPublicCotizacionData = async () => {
    try {
      const response = await appApi().get(`public/cotizaciones/`);
      const { estados, arrendamientos, enganches, residuales } = response.data;

      listEstados.value = estados;
      listArrendamientos.value = arrendamientos;
      listEnganches.value = enganches;
      listResiduales.value = residuales;
      loadingInitialData.value = false;
    } catch (e) {
      exceptionRequestMsg(e);
    }
  };

  const fetchMunicipiosByEstado = async (estado_id) => {
    loadingMunicipios.value = true;
    try {
      const response = await appApi().get(
        `public/cotizaciones/getMunicipiosByEstado?estado=${estado_id}`
      );
      listMunicipios.value = response.data;
    } catch (e) {
      exceptionRequestMsg(e);
    } finally {
      loadingMunicipios.value = false;
    }
  };

  const showModal = (btnType) => {
    if (btnType == "aprobar") {
      formAprobar.value = true;
      formRechazar.value = false;
    } else {
      formAprobar.value = false;
      formRechazar.value = true;
    }

    const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");
    const myModal = new bootstrap.Modal(modalAcciones.value);

    myModal.show();
  };

  return {
    formGenerales,
    showPhoneSection,
    showCodeSection,
    showGeneralesSection,
    showCotizacionSection,
    showCotizacionFinalizadaSection,
    globalPhone,
    cardContainerClassDimensions,
    listEnganches,
    listResiduales,
    listEstados,
    listMunicipios,
    listArrendamientos,
    fetchInitPublicCotizacionData,
    fetchMunicipiosByEstado,
    loadingMunicipios,
    cotizacionFinal,
    modalAcciones,
    showModal,
    formAprobar,
    formRechazar,
    Close,
    state,
    mostrarPasoDatos,
    mostrarPasoDatosEmpresa,
    mostrarPasoDatosActivo,
    mostrarPasoCotFinalizada,
    leyendaPaso,
  };
});

export default usePublicStore;
